// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"5d09bb0d","59":"8f265260","111":"732dc060","355":"a7034b0a","368":"0a08604c","629":"60c0a03d","891":"0004bef1","920":"8a57e811"}[chunkId] + ".chunk.css";
};